import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

API.interceptors.request.use((config) => {
  const branchId = typeof window !== "undefined" && window.localStorage.getItem("comfy-ledger-branch-id");
  if (branchId && !config.headers["X-Branch-ID"]) config.headers["X-Branch-ID"] = branchId;
  return config;
});

API.interceptors.response.use((response) => {
  const contentType = response.headers?.["content-type"] || "";
  if (contentType.includes("text/html")) {
    return Promise.reject(new Error("The application API is not available on this deployment."));
  }
  return response;
});

export function fmtErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.message === "string") return d.message;
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function isUpgradeError(e) {
  return e?.response?.data?.detail?.code === "UPGRADE_REQUIRED";
}

export function toastUpgrade(e) {
  const msg = e?.response?.data?.detail?.message || "This feature requires a higher plan.";
  toast.error(msg, {
    action: { label: "Upgrade", onClick: () => (window.location.href = "/billing") },
  });
}

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(Number(n || 0));

export const formatCurrency = (n, currency = "INR") =>
  new Intl.NumberFormat("en", { style: "currency", currency, maximumFractionDigits: 2 }).format(Number(n || 0));

export const CURRENCIES = [
  { code: "INR", name: "Indian Rupee" },
  { code: "USD", name: "US Dollar" },
  { code: "EUR", name: "Euro" },
  { code: "GBP", name: "British Pound" },
  { code: "AED", name: "UAE Dirham" },
  { code: "CAD", name: "Canadian Dollar" },
  { code: "AUD", name: "Australian Dollar" },
  { code: "SGD", name: "Singapore Dollar" },
  { code: "JPY", name: "Japanese Yen" },
];

export const num = (n) => new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 }).format(Number(n || 0));

export const today = () => new Date().toISOString().slice(0, 10);

export const monthStart = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
};

export const STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh",
  "Dadra & Nagar Haveli and Daman & Diu", "Delhi", "Goa", "Gujarat", "Haryana",
  "Himachal Pradesh", "Jammu & Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh",
  "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman & Nicobar Islands",
];

export const GST_RATES = [0, 0.25, 3, 5, 12, 18, 28];

export const TDS_RATES = [0, 0.1, 1, 2, 5, 10];

export const INDUSTRIES = [
  { value: "general", label: "General / Trading" },
  { value: "retail", label: "Retail" },
  { value: "pharma", label: "Pharma / Chemist" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "wholesale", label: "Wholesale / Distribution" },
  { value: "services", label: "Services" },
];

export const EXPENSE_CATEGORIES = [
  "Rent", "Salaries", "Fuel & Transport", "Office Supplies", "Marketing", "Utilities",
  "Travel", "Packaging", "Commission", "Repairs & Maintenance", "Professional Fees", "Other",
];

export const PAYMENT_MODES = ["Cash", "UPI", "Bank Transfer", "Cheque", "Card"];

export const TXN_CATEGORIES = [
  "Sales Receipt", "Purchase Payment", "Expense", "Salary", "Rent", "Tax Payment",
  "Bank Charges", "Interest Received", "Interest Paid", "Loan / EMI", "Transfer", "Investment", "Other",
];

export const CHART_COLORS = ["#0A2540", "#008A52", "#B7791F", "#E02424", "#64748B", "#334155"];
